import React, { useState } from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
    NavLink,
    Outlet,
    Navigate,
    useLocation,
} from "react-router-dom";

const Academic = () => {

    const location = useLocation();

    const [open, setOpen] =
        useState(false);

    const academicLinks = [

        {
            name: "Holidays",
            path: "holidays",
        },

        {
            name: "Class Monitors",
            path: "class-monitor",
        },

        {
            name: "Student Council",
            path: "student-council",
        },

        {
            name: "School House",
            path: "school-house",
        },

    ];

    return (

        <>

            {/* HEADER */}
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            <section className="w-full bg-[#EEF1F6] min-h-screen pt-6 pb-16 relative z-0">

                {/* MENU BAR */}
                <div className="w-full bg-[#D8A413] shadow-md border-y border-[#c8940d] relative z-10">

                    <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-2 md:gap-6 px-4 py-4">

                        {
                            academicLinks.map(
                                (
                                    item,
                                    index
                                ) => (

                                    <React.Fragment
                                        key={index}
                                    >

                                        <NavLink
                                            to={item.path}
                                            className={({
                                                isActive,
                                            }) =>
                                                `
                        px-6 py-3 rounded-md text-lg font-semibold transition-all duration-300

                        ${isActive
                                                    ? "bg-white text-[#0A3470] shadow-md"
                                                    : "text-white hover:bg-white hover:text-[#0A3470]"
                                                }
                      `
                                            }
                                        >

                                            {item.name}

                                        </NavLink>

                                        {
                                            index !==
                                            academicLinks.length - 1 && (

                                                <span className="hidden md:block text-white text-2xl font-light">

                                                    |

                                                </span>
                                            )
                                        }

                                    </React.Fragment>
                                )
                            )
                        }

                    </div>

                </div>

                {/* PAGE CONTENT */}
                <div className="max-w-7xl mx-auto px-4 md:px-8 mt-10 relative z-0">

                    {
                        location.pathname === "/academics" && (
                            <Navigate
                                to="holidays"
                                replace
                            />
                        )
                    }

                    <Outlet />

                </div>

            </section>

            {/* FOOTER */}
            <Footer />

        </>
    );
};

export default Academic;